import { FC, memo } from 'react';
import { Container, Card, Grid } from 'semantic-ui-react';
import { css } from '@emotion/react/macro';
import firstCardIllust from '../../../assets/index/HTMLillust_1.svg';
import secondCardIllust from '../../../assets/index/illust_2.svg';
import thrdCardIllust from '../../../assets/index/HTMLillust_3.svg';
import fourthCardIllust from '../../../assets/index/image4.png';
import fifthCardIllust from '../../../assets/index/image5.png';
import { MainSecondExpansionText } from '../../../text/MainSecondExpansionText';
import MainCard from '../../Molecules/MainCard';
import EntranceTitle from '../../Atoms/entrance/EntranceTitle';

const MainSecondExpansion: FC = memo(() => (
  <div css={containreMargin}>
    <Container style={{ width: '1024px' }}>
      <Grid textAlign="center">
        <EntranceTitle title="導入するメリット" color />
      </Grid>
      <Card.Group itemsPerRow={3} textAlign="center">
        <MainCard
          image={firstCardIllust}
          title={MainSecondExpansionText.first.title}
          description={MainSecondExpansionText.first.description}
        />
        <MainCard
          image={secondCardIllust}
          title={MainSecondExpansionText.second.title}
          description={
            <>
              {MainSecondExpansionText.second.description[0]}
              {MainSecondExpansionText.second.description[1]}
              <br />
              {MainSecondExpansionText.second.description[2]}
            </>
          }
        />
        <MainCard
          therd
          image={thrdCardIllust}
          title={
            <>
              <span css={titleScondStyle}>
                {MainSecondExpansionText.therd.title[0]}
              </span>
              <br />
              <span css={titleScondStyle && border}>
                {MainSecondExpansionText.therd.title[1]}
              </span>
            </>
          }
          description={
            <>
              {MainSecondExpansionText.therd.description[0]}
              {MainSecondExpansionText.therd.description[1]}
              <br />
              {MainSecondExpansionText.therd.description[2]}
            </>
          }
        />
      </Card.Group>
      <div css={bottomRowWrapper}>
        <Card.Group itemsPerRow={2} textAlign="center">
          <MainCard
            image={fourthCardIllust}
            title={MainSecondExpansionText.fourth.title}
            description={MainSecondExpansionText.fourth.description[0]}
          />
          <MainCard
            image={fifthCardIllust}
            title={MainSecondExpansionText.fifth.title}
            description={MainSecondExpansionText.fifth.description[0]}
          />
        </Card.Group>
      </div>
    </Container>
  </div>
));

const titleScondStyle = css`
  line-height: 1.8em;
`;

const border = css`
  border-bottom: 3px solid #224ea8;
  padding-bottom: 5px;
`;

const containreMargin = css`
  background-color: #fff;
  margin-bottom: 20px;
  padding-bottom: 100px;
`;

const bottomRowWrapper = css`
  width: 66.67%;
  margin: 0 auto;
`;

export default MainSecondExpansion;
